import * as stylex from '@stylexjs/stylex';
import { faSort, faSortDown, faSortUp } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';
import type { Sort } from '@/trendData/trendData.constants';

interface SortIconProps extends Partial<Omit<Sort, 'sortBy' | 'sortAsc'>> {
  sortProperty: string;
  /** property currently sorted on; null/absent when no sort is applied */
  sortBy?: string | null;
  sortAsc?: boolean | null;
}

/** Icon to indicate sorting, e.g. table column headers */
export const SortIcon = ({ sortProperty, sortBy, sortAsc }: SortIconProps) => {
  const isActiveSort = sortBy === sortProperty;
  const activeSortAsc = sortAsc ?? true;

  return (
    <Icon
      testId={`sortProperty_${sortProperty}`}
      icon={isActiveSort ? (activeSortAsc ? faSortUp : faSortDown) : faSort}
      type={isActiveSort ? 'info' : 'dark-gray'}
      xstyle={styles.sortIcon}
    />
  );
};

const styles = stylex.create({ sortIcon: { marginLeft: 5, cursor: 'pointer' } });
